<script>
import {
  authComputed,
  notificationComputed,
  notificationMethods,
} from '@state/helpers'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import appConfig from '@src/app.config'
import { mapActions, mapGetters } from 'vuex'
import axios from '@axios'

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    user: {
      type: Object,
      required: false,
      default: () => null,
    },
    isMenuOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {},
      systemTitle: appConfig.title,
      currntTime: 0,
      isRefresh: false,
    }
  },
  computed: {
    ...authComputed,
    ...notificationComputed,
    ...mapGetters('billing', ['balance', 'blockedBalance']),
    ...mapGetters('auth', ['isAdmin', 'currentUser', 'userProfile']),
    ...mapGetters('userNotification', ['allNotifications']),
    newNotification() {
      return Array.isArray(this.allNotifications) ? this.allNotifications.filter(n => n.status === 0).length : 0
    },
  },
  created() {
    if (!this.isAdmin) {
      this.getNotifications()
    }

    this.getBalance()
  },
  mounted() {
    let showAnnouncement = this.currentUser
      ? !this.currentUser.acknowledgement
      : false
    if (showAnnouncement) this.$bvModal.show('announcement')
  },
  methods: {
    ...notificationMethods,
    ...mapActions('billing', ['getBalance']),
    ...mapActions('account', ['updateAccount']),
    ...mapActions('userNotification', ['getNotifications', 'updateStatusNotification', 'markToRead', 'removeNotification', 'removeNotifications']),

    submitReadedAnnouncement() {
      this.$bvModal.hide('announcement')
      let user = this.currentUser
      let submitForm = {
        email: user.email,
        id: user.id,
        acknowledgement: true,
      }
      this.updateAccount(submitForm)
    },
    isProduct(product) {
      let show = false
      if (this.currentUser) {
        this.currentUser.subscriptions.forEach((element) => {
          if (element === product) show = true
        })
      }
      return show
    },
    deleteNotifications() {
      this.removeNotifications()
    },
    toggleMenu() {
      this.$parent.toggleMenu()
    },
    toggleRightSidebar() {
      this.$parent.toggleRightSidebar()
    },
    getTime(lastTime) {
      return this.formatTime(this.currntTime - lastTime)
    },
    formatTime(time) {
      if (time >= 0) {
        time /= 1000
        var hrs = ~~(time / 3600)
        var mins = ~~((time % 3600) / 60)
        var secs = ~~time % 60
        var ret = ''
        if (hrs > 0) {
          ret += '' + hrs + ' hour '
        }
        if (mins > 0) {
          ret += '' + mins + ' minute '
        }
        ret += '' + secs + ' second ago'
        return ret
      }
      return '0 second ago'
    },
    fetchAndRedirect(url) {
      axios.get('/auth/redirect').then((response) => {
        if (response.data && response.data.bearer_token) {
          this.redirectToExternal(url, response.data.bearer_token)
        }
      })
    },
    redirectToExternal(url, token) {
      const fullUrl = `${url}?token=${encodeURIComponent(token)}`
      window.location.href = fullUrl
    },
    async refreshBalance() {
      this.isRefresh = !this.isRefresh
      await this.getBalance() // Added await to handle async properly
      this.isRefresh = !this.isRefresh
    },
    remove(announcement) {
      this.$store.dispatch('announcement/removeNotification', announcement)
    },
    updateStatus(ann) {
      this.$store.dispatch('userNotification/updateStatusNotification', ann)
    }
  },
}
</script>


<template>
  <!-- Topbar Start -->
  <div class="dev-nb navbar navbar-expand flex-column flex-md-row navbar-custom">
    <div class="container-fluid">
      <!-- LOGO -->
      <a href="/" class="navbar-brand mr-0 mr-md-2 logo">
        <span class="logo-lg">
          <img src="@assets/images/logo_dark.svg" alt="pastgate" height="50px" />
        </span>
        <span class="logo-sm">
          <img src="@assets/images/logo_dark.svg" alt="pastgate" height="32" />
        </span>
      </a>

      <ul class="navbar-nav bd-navbar-nav flex-row list-unstyled menu-left mb-0">
        <li class>
          <button class="button-menu-mobile open-left disable-btn mr-0" :class="{ open: isMenuOpened }"
            @click="toggleMenu">
            <feather type="menu" class="menu-icon align-middle"></feather>
            <feather type="x" class="close-icon"></feather>
          </button>
        </li>
      </ul>
      <div class="d-none d-xl-flex flex-column ml-5">
        <h6 class="m-0 text-white">
          <div class="d-flex justify-content-around">
            <span class="align-self-center">$ {{ balance }} </span>
            <i v-if="!isRefresh" class="uil uil-sync mr-1 align-self-center ml-2 clickable" @click="refreshBalance"></i>
            <div v-else class="spinner-border spinner-border-sm" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
          <span v-if="blockedBalance !== '0.0000'" class="cus-text-muted">
            (Blocked {{ blockedBalance }})</span>
          <hr style="background-color: #fff" class="mt-1 mb-1 text-white" />
        </h6>
        <h6 style="font-size: 12px" class="m-0 clickable text-white" @click="$router.push('/billing/topup')"><i
            class="uil uil-atm-card mr-1"></i>Request topup</h6>
      </div>
      <ul class="
          navbar-nav
          flex-row
          ml-auto
          d-flex
          list-unstyled
          topnav-menu
          float-right
          mb-0
        ">
        <b-nav-item-dropdown id="bell-notification" right variant="white" class="notification-list"
          title="8 new unread notifications" menu-class="dropdown-lg">
          <VuePerfectScrollbar class="noti-scroll">
            <!-- item-->
            <b-dropdown-text v-for="notification in allNotifications" :key="notification.id" href="javascript:void(0);"
              class="notify-item border-bottom">
              <div class="notify-icon bg-primary">
                <i class="uil uil-user-plus"></i>
              </div>
              <p class="notify-details">
                {{ notification.message }}
                <small class="text-muted">{{ getTime(notification.id) }}</small>
              </p>
            </b-dropdown-text>
          </VuePerfectScrollbar>
          <!-- All-->
          <b-dropdown-text href="javascript:void(0);"
            class="text-center text-primary notify-item notify-all border-top">
            View all
            <i class="fi-arrow-right"></i>
          </b-dropdown-text>
        </b-nav-item-dropdown>

        <b-nav-item-dropdown v-if="user !== null" right class="notification-list align-self-center profile-dropdown"
          toggle-class="nav-user mr-0">
          <template v-slot:button-content>
            <div class="media user-profile">
              <img src="@assets/images/users/avatar-7.jpg" alt="user-image" class="rounded-circle align-self-center" />
              <div v-if="user !== null" class="media-body text-left">
                <h6 class="pro-user-name ml-2 my-0">
                  <span>{{ user.name }}</span>
                  <span class="pro-user-desc text-muted d-block mt-1">Administrator</span>
                </h6>
              </div>
              <feather type="chevron-down" class="ml-2 align-self-center"></feather>
            </div>
          </template>

          <b-dropdown-item href="/pages/profile" class="notify-item p-0">
            <feather type="user" class="icon-dual icon-xs mr-2"></feather>
            <span>My Account</span>
          </b-dropdown-item>

          <b-dropdown-item href="javascript:void(0);" class="notify-item p-0">
            <feather type="settings" class="icon-dual icon-xs mr-2"></feather>
            <span>Settings</span>
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>

          <b-dropdown-item href="/logout" class="notify-item p-0">
            <feather type="log-out" class="icon-dual icon-xs mr-2"></feather>
            <span>Logout</span>
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </ul>
      <a href="#" class="btn btn-support btn-primary-submit btn-secondary d-flex" target="_blank"
        @click.prevent="fetchAndRedirect('https://support.plasgate.com/auth')">
        <i class="uil uil-question-circle mr-2 align-middle" style="font-size: 16px"></i>
        Support
      </a>
      <h6 class="d-block d-xl-none m-0 mr-2 text-white clickable" @click="$router.push('/billing/topup')">
        $ {{ balance }}
      </h6>
      <h6 v-if="blockedBalance !== '0.0000'" class="d-block d-xl-none ml-2 mr-3 cus-text-muted ">
        (Blocked : {{ blockedBalance }})
      </h6>
      <div>
        <b-dropdown v-if="isAdmin === false" id="dropdown-2" class="m-md-3 pg-dropdown-top-bar" variant="outline"
          toggle-class="pg-top-menu-dropdown" right>
          <template slot="button-content">
            <i class="uil uil-bell notification test">
              <span class="badge">{{ newNotification }}</span>
            </i>
            <i class="uil uil-angle-down"></i>
          </template>
          <div v-if="allNotifications">
            <div id="scrollspy-nested" style="position:relative; height:200px; overflow-y:auto"
              class="pl-4 pr-4 align-self-center scrollspy">
              <div v-for="notification in allNotifications.filter(n => n.status === 0)" :key="notification.id"
                class="dropdown notify-item border-bottom d-flex justify-content-between">
                <router-link :to="{
                  name: 'UserAnnouncement',
                  params: { id: notification.id },
                }">
                  <p class="notify-details">{{ notification.announcement.title }}</p>
                </router-link>
                <i v-if="notification.status === false"
                  class="uil uil-circle text-success d-flex align-items-center"></i>
              </div>
            </div>
          </div>
          <router-link to="/notification"
            class="dropdown-item text-center text-primary notify-item notify-all border-top">View All
          </router-link>
        </b-dropdown>
      </div>
      <div>
        <b-dropdown id="dropdown-1" class="m-md-0 pg-dropdown-top-bar" toggle-class="pg-top-menu-dropdown"
          variant="outline" right>
          <template slot="button-content">
            <i class="uil uil-user-circle"></i>
            Account
            <i class="uil uil-angle-down"></i>
          </template>
          <b-dropdown-text>Manage account</b-dropdown-text>
          <b-dropdown-item class="pg-dropdown-item" to="/account/users">User</b-dropdown-item>
          <b-dropdown-item to="/role">Role</b-dropdown-item>
          <b-dropdown-item to="/account/groups">Group</b-dropdown-item>

          <section v-if="isProduct('sms_gateway') || isAdmin">
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-text>Phonebook</b-dropdown-text>
            <b-dropdown-item to="/phonebook/contact">Contact</b-dropdown-item>
            <b-dropdown-item to="/phonebook/group">Group</b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
          </section>
          <section v-if="
            isProduct('sms_gateway') ||
            isProduct('ip_verification') ||
            isAdmin
          ">
            <b-dropdown-text>SMPP & API</b-dropdown-text>
          </section>

          <b-dropdown-item v-if="isProduct('sms_gateway') || isAdmin" to="/token/sms-gateway">SMS
            Gateway</b-dropdown-item>
          <b-dropdown-item v-if="isProduct('ip_verification') || isAdmin" to="/token/ipverification">IP
            Verification</b-dropdown-item>
        </b-dropdown>
      </div>
      <div>
        <b-dropdown id="dropdown-2" class="m-md-3 pg-dropdown-top-bar" variant="outline"
          toggle-class="pg-top-menu-dropdown" right>
          <template slot="button-content">
            <i class="uil uil-usd-circle"></i>
            Billing
            <i class="uil uil-angle-down"></i>
          </template>
          <b-dropdown-item to="/billing/topup">Top up</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-text>Manage billing </b-dropdown-text>
          <b-dropdown-item to="/billing/package">Package</b-dropdown-item>
          <b-dropdown-item to="/billing/rate">Rate</b-dropdown-item>
          <b-dropdown-item v-if="isAdmin" to="/billing/tax">Tax</b-dropdown-item>
        </b-dropdown>
      </div>
      <div>
        <b-dropdown id="dropdown-3" class="m-md-0 pg-dropdown-top-bar" variant="outline"
          toggle-class="pg-top-menu-dropdown" right>
          <template slot="button-content">
            <div class="d-flex">
              <img :src="userProfile.photo" style="background-color: #fff"
                class="avatar-sm rounded-circle mr-sm-2 mr-1" />
              <h6 style="color: #fff" class="d-flex flex-row">
                <div class="d-none d-sm-flex">{{ userProfile.firstName }} {{ userProfile.lastName }} </div><i
                  class="uil uil-angle-down"></i>
              </h6>
            </div>
          </template>
          <b-dropdown-text class="d-sm-none d-flex">{{ userProfile.firstName }}
            {{ userProfile.lastName }}</b-dropdown-text>
          <b-dropdown-item to="/account/profile">Profile</b-dropdown-item>
          <b-dropdown-item to="/product">Subcription</b-dropdown-item>
          <b-dropdown-item to="/account/profile">Security</b-dropdown-item>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item href="/logout">
            Logout
            <i class="uil uil-power ml-5 text-danger"></i></b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
    <b-modal id="announcement" content-class="shadow" centered size="lg" :hide-header="true" :hide-footer="true"
      no-close-on-backdrop body-class="p-0">
      <img class="col-12 p-0" src="/assets/image/announcement.svg" />
      <div class="d-flex justify-content-around">
        <b-button class="m-3 btn btn-primary-submit btn-secondary" @click="submitReadedAnnouncement">CLOSE</b-button>
      </div>
    </b-modal>
  </div>
  <!-- end Topbar -->
</template>

<style lang="scss">
.noti-scroll {
  height: 220px;
}

.ps>.ps__scrollbar-y-rail {
  width: 8px !important;
  background-color: transparent !important;
}

.ps>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps.ps--in-scrolling.ps--y>.ps__scrollbar-y-rail>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:active>.ps__scrollbar-y,
.ps>.ps__scrollbar-y-rail:hover>.ps__scrollbar-y {
  width: 6px !important;
}

.button-menu-mobile {
  outline: none !important;
}

.cus-text-muted {
  color: #e4e4e4;
  font-weight: 400;
}

.test {
  color: black;
  background-color: white;
  border-radius: 10px;
  padding: 2px;
}

a {
  color: black;
}

.notification {
  background-color: white;
  text-decoration: none;
  padding: 3px 6px;
  position: relative;
  display: inline-block;
  border-radius: 15px;
}

.notification .badge {
  position: absolute;
  top: -8px;
  right: -5px;
  padding: 3px 6px;
  border-radius: 50%;
  background: red;
  color: white;
}
</style>
